document.addEventListener("DOMContentLoaded", () => {
  const addOneTimeBtn = document.getElementById("add-bundle-onetime");
  const addSubBtn = document.getElementById("add-bundle-subscription");

  const oneTimeSection = document.querySelector(".one-time-bundle");
  const subscriptionSection = document.querySelector(".subscription-bundle");

  if (!addOneTimeBtn || !addSubBtn) return;

  let runCounter = 0;
  let debounceTimer = null;
  const DEBOUNCE_MS = 80;

  function getCurrentPurchaseType() {
    return (
      document.querySelector("[data-type].active")?.dataset.type ||
      document.querySelector(".purchase-type.active")?.dataset.type ||
      "subscription"
    );
  }

  function getActiveBundleGroup(sectionEl) {
    if (!sectionEl) return null;

    return (
      sectionEl.querySelector(".bundle-group.active:not(.hidden)") ||
      sectionEl.querySelector(".bundle-group.active") ||
      sectionEl.querySelector(".bundle-group:not(.hidden)") ||
      sectionEl
    );
  }

  function getActiveSubscriptionGroup() {
    const activeSetButton =
      subscriptionSection?.querySelector(
        ".bundle-option.active[data-target]",
      ) ||
      document.querySelector(".bundle-option.active[data-target]") ||
      document.querySelector("[data-target].active");

    const targetSet = activeSetButton?.dataset?.target?.trim();

    if (targetSet && subscriptionSection) {
      const setGroup = subscriptionSection.querySelector(
        `[data-bundle-set="${targetSet}"]`,
      );

      if (setGroup) return setGroup;
    }

    return getActiveBundleGroup(subscriptionSection);
  }

  function areAllSlotsFilled(container) {
    if (!container) return false;

    const slots = container.querySelectorAll(".bundle-product");
    if (!slots.length) return false;

    return Array.from(slots).every((slot) => {
      const variantId = slot.dataset.id || "";
      const productId = slot.dataset.product || "";

      return variantId.trim() !== "" && productId.trim() !== "";
    });
  }

  function cacheDefaultAtcText(button) {
    const textSpan = button.querySelector("[data-atc-text]");
    if (!textSpan) return;

    if (!textSpan.dataset.defaultAtcText) {
      textSpan.dataset.defaultAtcText = textSpan.textContent.trim();
    }
  }

  function updateButtonText(button, isComplete) {
    const textSpan = button.querySelector("[data-atc-text]");
    if (!textSpan) return;

    cacheDefaultAtcText(button);

    const defaultText = textSpan.dataset.defaultAtcText || "";
    const incompleteText =
      textSpan.getAttribute("data-atc-text") || defaultText;

    textSpan.textContent = isComplete ? defaultText : incompleteText;
  }

  function updateButtonState(button, isComplete) {
    button.disabled = false;

    button.classList.toggle("is-bundle-incomplete", !isComplete);
    button.classList.toggle("is-bundle-complete", isComplete);

    updateButtonText(button, isComplete);
  }

  function runCheckIfLatest(myRunId) {
    if (myRunId !== runCounter) return;

    const oneTimeGroup = getActiveBundleGroup(oneTimeSection);
    const subscriptionGroup = getActiveSubscriptionGroup();

    const oneTimeComplete = areAllSlotsFilled(oneTimeGroup);
    const subscriptionComplete = areAllSlotsFilled(subscriptionGroup);

    if (myRunId === runCounter) {
      updateButtonState(addOneTimeBtn, oneTimeComplete);
      updateButtonState(addSubBtn, subscriptionComplete);
    }
  }

  function scheduleCheck() {
    const myRunId = ++runCounter;

    if (debounceTimer) clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      runCheckIfLatest(myRunId);
    }, DEBOUNCE_MS);
  }

  document.addEventListener("click", (e) => {
    if (
      e.target.closest('[data-type="one-time"]') ||
      e.target.closest('[data-type="subscription"]') ||
      e.target.closest("[data-target]") ||
      e.target.closest(".bundle-product") ||
      e.target.closest("[data-popup-trigger]") ||
      e.target.closest(".add-btn") ||
      e.target.closest(".bundle-collection__image") ||
      e.target.closest(".quickview__select") ||
      e.target.closest(".remove-btn") ||
      e.target.closest(".bundle-popup__selected-remove")
    ) {
      scheduleCheck();
    }
  });

  const wrapper = document.querySelector(".bundle-wrapper") || document.body;

  const observer = new MutationObserver(() => {
    scheduleCheck();
  });

  observer.observe(wrapper, {
    attributes: true,
    subtree: true,
    attributeFilter: ["class", "data-id", "data-product", "data-target"],
    childList: true,
  });

  cacheDefaultAtcText(addOneTimeBtn);
  cacheDefaultAtcText(addSubBtn);

  addOneTimeBtn.disabled = false;
  addSubBtn.disabled = false;

  scheduleCheck();

  window.bundleButtons_checkSlots = scheduleCheck;
});
